<script>
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  components: {
    Datatable,
    Pagination,
  },

  props: {
    type: {
      type: String,
    },
  },

  data() {
    let sortOrders = []; // select sortOrder
    // definisi kolom yang dipakai
    let columns = [
			{ width: "50px", label: "No", name: "-" },
			{ width: "auto", label: "User ID", name: "user_id" },
			{ width: "auto", label: "Code", name: "-" },
			{ width: "auto", label: "Status", name: "status" },
			{ width: "auto", label: "Tanggal Antrian", name: "created_at" },
			{ width: "200px", label: "Aksi", name: "-" }
		];
    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      tableData: {
        columns: columns,
        sortKey: "code",
        sortOrders: sortOrders,
        loading: true,
        data: [],
        filter: {
          draw: 0,
          page: 1,
          per_page: 10,
          search: "",
          column: 'code',
          dir: 'asc',
          type: this.type,
        },
        pagination: {
          lastPage: "",
          currentPage: "",
          total: "",
          lastPageUrl: "",
          nextPageUrl: "",
          prevPageUrl: "",
          from: "",
          to: "",
          links: "",
        },
      },
    };
  },

  methods: {
    getDataTable(resetPage = true) {
      this.tableData.filter.page = resetPage ? 1 : this.tableData.filter.page;
      let self = this;
      self.tableData.loading = true;
      self.tableData.filter.draw++;

      let payload = { ...this.tableData.filter };

      var config = {
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "export-job",
        params: payload,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data;
          if (response_data.meta.code == 200) {
            self.tableData.data = response_data_fix.data;
            self.configPagination(response_data_fix);
            self.tableData.pagination.currentPage = response_data_fix.current_page;
            self.tableData.loading = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data_fix.data.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    configPagination(data) {
      this.tableData.pagination.lastPage = data.last_page;
      this.tableData.pagination.currentPage = data.current_page;
      this.tableData.pagination.total = data.total;
      this.tableData.pagination.lastPageUrl = data.last_page_url;
      this.tableData.pagination.nextPageUrl = data.next_page_url;
      this.tableData.pagination.prevPageUrl = data.prev_page_url;
      this.tableData.pagination.from = data.from;
      this.tableData.pagination.to = data.to;
      this.tableData.pagination.links = data.links;
    },
    sortBy(key) {
      let self = this;
      self.tableData.sortKey = key;
      self.tableData.sortOrders[key] = self.tableData.sortOrders[key] * -1;
      self.tableData.filter.column = key;
      self.tableData.filter.dir = self.tableData.sortOrders[key] === 1 ? "asc" : "desc";
      self.getDataTable();
    },
    toPage(url) {
      let link = new URLSearchParams(url);
      this.tableData.filter.page = link.get("page");
      this.getDataTable(false);
    },

    formatDate(date) {
			if (!date) return "-";
			const [datePart, timePart] = date.split(" ");
			const [year, month, day] = datePart.split("-");
			return `${day}-${month}-${year} ${timePart}`;
		},

    download(row_data) {
      axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "export-job/download",
        params: {
          code: row_data.code,
          type: this.tableData.filter.type,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
        responseType: "blob",
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          const contentDisposition = response.headers["content-disposition"];
          let fileName = row_data.code + ".xlsx";
          if (contentDisposition) {
            const match = contentDisposition.match(/filename="?(.+)"?/);
            if (match) fileName = match[1];
          }
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Gagal!",
            text: "Terjadi kesalahan saat mengunduh file.",
          });
        });
    },
  },
};
</script>

<template>
    <div class="row">
      <div class="col-12">
        <datatable
          :columns="tableData.columns"
          :sortKey="tableData.sortKey"
          :sortOrders="tableData.sortOrders"
          @sort="sortBy"
        >
          <tbody>
            <tr v-if="tableData.loading">
              <td colspan="99" class="text-center">
                <i class="fas fa-spinner fa-spin"></i> Loading...
              </td>
            </tr>
            <tr v-else-if="!tableData.data || tableData.data.length === 0" class="text-center">
              <td class="text-center" colspan="99">
                Data Tidak Tersedia
              </td>
            </tr>
            <tr
              v-else
              v-for="(row_data, key_data) in tableData.data"
              :key="row_data.idjadwal_peserta"
            >
              <td class="text-center">
                {{ (tableData.pagination.currentPage - 1) * (tableData.filter.per_page || 10) + key_data + 1 }}
              </td>
              <td class="text-center">{{ row_data.user_id }}</td>
              <td class="text-center">{{ row_data.code || "-" }}</td>
              <td class="text-center">{{ row_data.status }}</td>
              <td class="text-center">{{ formatDate(row_data.created_at) }}</td>
              <td class="text-center">
                <div class="btn-group btn-group-sm">
                  <button
                    v-if="row_data.status === 'completed'"
                    class="btn btn-info btn-sm"
                    @click="download(row_data)"
                  >
                    <i class="fa fa-download"></i> Download
                  </button>
                  <button
                    v-else
                    class="btn btn-secondary btn-sm"
                    disabled>
                    <i class="fa fa-download"></i> Download
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </datatable>
      </div>
      <div class="col-12">
        <pagination :pagination="tableData.pagination" @to-page="toPage"></pagination>
      </div>
    </div>
</template>